import { call, put, select } from 'redux-saga/effects';

import { setDiscounts } from '../../../effects/organization';
import { callAPI, METHODS } from '../../api';
import { RESOURCES } from '../../../../helpers/constants';

export default function* getOrganizationDetails() {
  const organizationId = yield select((state) => state.organization.uuid);
  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const url = `${dpaApiBaseUrl + RESOURCES.ORGA}/${organizationId}/discounts`;
  try {
    const { success, result } = yield call(callAPI, {
      url,
      method: METHODS.GET,
    });
    if (success) {
      yield put(setDiscounts(result));
    } else {
      yield put(setDiscounts({ error: true }));
    }
  } catch (e) {
    console.error(e);
    yield put(setDiscounts({ error: true }));
  }
}
